"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SVGWrapper = exports.Icon = void 0;
var _reactSvg = require("react-svg");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
const useConfig = function () {
  return {
    iconPath: "https://www.lexus.com/content/dam/lexus/svgs/"
  };
};
const SVGWrapper = exports.SVGWrapper = _styledComponents.default.div`
	& div, & svg {
		width: 100%;
		height: 100%;
	}
`;
const Icon = function (props) {
  const {
    iconPath
  } = useConfig();
  const {
    color,
    fill,
    height,
    icon,
    src,
    stroke,
    style,
    width,
    alt,
    ...rest
  } = props;
  const styleAttr = {
    width: Number.isInteger(width) ? `${width}px` : width,
    height: Number.isInteger(height) ? `${height}px` : height,
    fill,
    stroke,
    color,
    ...style
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SVGWrapper, {
    "data-testid": "Icon",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSvg.ReactSVG, {
      src: src !== null && src !== void 0 ? src : `${iconPath}${icon}.svg`,
      renumerateIRIElements: false,
      style: styleAttr,
      beforeInjection: function (svg) {
        svg.setAttribute("aria-label", alt || "");
        svg.setAttribute("alt", alt || "");
      },
      ...rest
    })
  });
};
exports.Icon = Icon;
var _default = exports.default = Icon;